import {required, ValidationResult, Validator} from '@/types/validation/ValidationResult';
import {InquiryAnswerRegisterRequest} from '@/types/inquiry/Inquiry';

export class InquiryAnswerRegisterChecker {
  result: ValidationResult;

  constructor(result: InquiryAnswerRegisterRequest) {
    const checker = new ValidationResult(InquiryAnswerRegisterValidator);
    checker.validate(result);
    this.result = checker;
  }

  get hasErrors(): boolean {
    return this.result.hasErrors;
  }

  get getMessages(): string[] {
    return this.result.getMessages();
  }
}

export const InquiryAnswerRegisterValidator: Validator[] = [
  {
    name: 'title',
    constraints: [
      {method: required, message: '件名を入力してください'},
    ],
  },
  {
    name: 'content',
    constraints: [
      {method: required, message: '内容を入力してください'},
    ],
  },
];
